import magic from '../lib/magic';

export const generateReplicateImage = async (prompt, model = 'recraft') => {
  try {
    console.log(`🎨 Starting ${model} image generation with prompt:`, prompt);
    
    const didToken = await magic.user.getIdToken();
    const response = await fetch('/api/generate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${didToken}`
      },
      body: JSON.stringify({ 
        prompt,
        aiModel: model
      })
    });
    
    console.log('📡 Response status:', response.status);
    
    if (!response.ok) {
      const errorData = await response.json();
      console.error('❌ API error:', errorData);
      throw new Error(errorData.error || 'Failed to generate image');
    }

    const data = await response.json();
    console.log('📦 Response data:', data);

    const imageUrl = data.data[0].url;
    if (!imageUrl) {
      throw new Error('No image URL in response');
    }

    return {
      url: imageUrl,
      prompt: prompt,
      timestamp: new Date().toISOString(),
      isSvg: true
    };
  } catch (error) {
    console.error('❌ Error generating image:', error);
    error.isGenerationError = true;
    throw error;
  }
}; 